export default "__VITE_ASSET__DdREiua5__"